import React, {Component} from "react";
import {Col, Container, Row} from "react-bootstrap";
import {TextInput} from "../../../../components";
import NumberInput from "../../../../components/number-input/NumberInput";
import {Dropdown as PrimeDropdown} from "primereact/components/dropdown/Dropdown";
import EnumCoPayUnit from "../../enums/EnumCoPayUnit";
import DirectBillingItemAuthorizationStatusEnum from "../../enums/DirectBillingItemAuthorizationStatusEnum";
import NotificationService from "../../../../services/notification-service/NotificationService";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import FormField from "../../../../components/form/FormField";
import ValidationUtil from "../../../../components/form/validator/ValidationUtil";

export default class PreApprovalDetailMultipleEditModal extends Component {
    constructor(props) {
        super(props);

        const firstSelectedItem = this.props.selectedItems?.[0] || {};

        this.state = {
            coPay: firstSelectedItem.coPay || this.props.coPay || "",
            coPayUnit: firstSelectedItem.coPayUnit || this.props.coPayUnit || "",
            coPayMax: firstSelectedItem.coPayMax || this.props.coPayMax || "",
            responseStatus: firstSelectedItem.responseStatus || this.props.responseStatus || ""
        }
        
        this.formFields = [];
    }

    confirmDetails = async () => {
        // Validate form fields before proceeding
        if (!ValidationUtil.isValid(this.formFields)) {
            return;
        }

        let failedItems = [];
        for (let i = 0; i < this.props.selectedItems.length; i++) {
            const directBillingItem = this.props.selectedItems[i];
            directBillingItem.coPay = this.state.coPay;
            directBillingItem.coPayUnit = this.state.coPayUnit;
            directBillingItem.coPayMax = this.state.coPayMax;
            directBillingItem.authorizationStatus = this.state.responseStatus;

            await RemotingService.postRemoteCall(`api/insurance/coordinator/direct-billing-item/${directBillingItem.id}/confirm-details`,
                directBillingItem, () => {
                    NotificationService.showNotification({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Item details confirmed successfully'
                    });
                }, () => {
                    failedItems.push(directBillingItem);
                });
        }

        if (failedItems.length > 0) {
            NotificationService.showNotification({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to confirm details for cpt(s) ${failedItems.map(i => i.cpt.cptCode)}.`
            });
        }

        this.props.onConfirm();
    }

    renderSelectedItems() {
        return (
            <div style={styles.selectedItemsContainer}>
                <h4 style={{ marginBottom: '15px' }}>Selected CPT Items</h4>
                <div style={styles.itemsList}>
                    {this.props.selectedItems.map((item, index) => (
                        <div key={index} style={styles.itemCard}>
                            <div style={styles.itemHeader}>
                                <span style={styles.cptCode}>{item.cpt.cptCode}</span>
                                <span style={styles.cptName}>{item.cpt.name}</span>
                            </div>
                            <div style={styles.itemDetails}>
                                <div>Description: {item.cpt.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <Container className={"InputModal"} style={{width: 600}}>
                <Row>
                    <Container>
                        {this.renderSelectedItems()}
                    </Container>
                </Row>
                <Row>
                    <Col>
                        <Container>
                            <Field label="Co-Pay"
                                   body={
                                       <FormField
                                           ref={(ref) => this.formFields.push(ref)}
                                           required
                                           validateOn={this.state.coPay}
                                       >
                                           <NumberInput
                                               value={this.state.coPay}
                                               onChange={value => this.setState({coPay: value})}
                                               min={0}
                                           />
                                       </FormField>
                                   }/>
                            <Field label="Co-Pay Unit"
                                   body={
                                       <FormField
                                           ref={(ref) => this.formFields.push(ref)}
                                           required
                                           validateOn={this.state.coPayUnit}
                                       >
                                           <PrimeDropdown
                                               optionLabel="name" optionValue="key"
                                               options={EnumCoPayUnit.toArray()}
                                               filter={true}
                                               value={this.state.coPayUnit}
                                               onChange={e => this.setState({coPayUnit: e.value})}
                                           />
                                       </FormField>
                                   }/>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Field label="Max Co-Pay"
                                   body={
                                       <FormField
                                           ref={(ref) => this.formFields.push(ref)}
                                           min={0}
                                           required
                                           validateOn={this.state.coPayMax}
                                       >
                                           <NumberInput
                                               value={this.state.coPayMax}
                                               onChange={value => this.setState({coPayMax: value})}
                                               min={0}
                                           />
                                       </FormField>
                                   }/>
                            <Field label="Insurance Response Status"
                                   body={
                                       <FormField
                                           ref={(ref) => this.formFields.push(ref)}
                                           required
                                           validateOn={this.state.responseStatus}
                                       >
                                           <PrimeDropdown optionLabel="name" optionValue="key"
                                                          options={DirectBillingItemAuthorizationStatusEnum.toArray()}
                                                          value={this.state.responseStatus}
                                                          onChange={e => this.setState({responseStatus: e.value})}/>
                                       </FormField>
                                   }/>
                        </Container>
                    </Col>
                </Row>
            </Container>
        );
    }
}

class Field extends Component {
    render() {
        const {label, body} = this.props;
        return <div style={{display: 'grid', marginBottom: 8}}>
            <div><b>{label}</b></div>
            {body}
        </div>;
    }
}

const styles = {
    selectedItemsContainer: {
        marginBottom: '20px',
        padding: '10px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
    },
    itemsList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    itemCard: {
        padding: '10px',
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    itemHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px',
    },
    cptCode: {
        fontWeight: 'bold',
        color: '#2c3e50',
    },
    cptName: {
        color: '#34495e',
    },
    itemDetails: {
        fontSize: '0.9em',
        color: '#7f8c8d',
    },
};